import BulkChangeLeadPropertyModal from './BulkChangeLeadPropertyModal';

export default BulkChangeLeadPropertyModal;
